import { Avatar, Col, Image, Row, Space, Tag, Typography } from 'antd';

import { StarFilled } from '@ant-design/icons';
import styled from 'styled-components';
import DefaultAvatar from '../../assets/img/DefaultAvatar.jpg';
import TagStatus from './TagStatus';

const { Text } = Typography;

const TherapistInfoStyled = styled(Row)`
    gap: 16px;
    .therapist-detail {
        gap: 2.5px !important;
    }
`;

function TherapistInfo({
    fullName,
    photo,
    therapisDetail,
    useAvatar = false,
    avatarSize,
    align,
    rating,
    customTag,
    renderActionButton,
    status,
    hiddenTag = false,
}) {
    const onImageError = (event) => {
        const newSource = DefaultAvatar;
        event.target.src = newSource;
    };
    return (
        <TherapistInfoStyled wrap={false} align={align}>
            <Col flex="none">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {useAvatar ? (
                        <Avatar
                            src={
                                <Image
                                    preview={false}
                                    height={avatarSize}
                                    width={avatarSize}
                                    style={{ objectFit: 'cover' }}
                                    src={photo}
                                    onError={onImageError}
                                />
                            }
                            size={avatarSize}
                        />
                    ) : (
                        <Image
                            style={{ borderRadius: 6, objectFit: 'cover' }}
                            src={photo}
                            width={71}
                            height={99}
                            onError={onImageError}
                            preview={false}
                        />
                    )}
                    {!hiddenTag && (
                        <TagStatus
                            style={{ marginRight: 'unset', marginTop: '-8px', width: 63, zIndex: 1, textOverflow: 'ellipsis', overflow: 'hidden' }}
                            status={status}
                        />
                    )}
                </div>
            </Col>
            <Col flex="auto">
                <Space direction="vertical" style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', flexWrap: 'nowrap' }}>
                        <div>
                            <Space direction="vertical" className="therapist-detail">
                                <Text style={{ fontSize: '16px', fontWeight: 500 }}>{fullName}</Text>
                                {therapisDetail}
                            </Space>
                        </div>

                        {customTag || (
                            <Tag color="warning" style={{ marginRight: 'unset' }} icon={<StarFilled />}>
                                {rating}
                            </Tag>
                        )}
                    </div>
                    {renderActionButton?.()}
                </Space>
            </Col>
        </TherapistInfoStyled>
    );
}

export default TherapistInfo;
